import { createSelector } from '@reduxjs/toolkit'
import { RootState } from '../store'

const getMapData = (state: RootState) => state.map.data

const getMapCenter = (state: RootState) => state.map.data.center
const getMapZoom = (state: RootState) => state.map.data.zoom
const getMapEase = (state: RootState) => state.map.zoomTransition.ease
const getMapSpeed = (state: RootState) => state.map.zoomTransition.speed
const getMapCurve = (state: RootState) => state.map.zoomTransition.curve
const getCurrentMarker = (state: RootState) => state.map.data.currentMarker

const getPopUpDetail = (state: RootState) => state.map.popupDetail

const getIncludeTransient = (state: RootState) => state.map.includeTransient

const makeMarkerToolTipDetail = createSelector(
  [getPopUpDetail],
  (markerDetail) => {
    const {details} = markerDetail
    return details
  }
)

const makeMapZoomDetail = createSelector(
  getMapZoom,
  getMapEase,
  getMapSpeed,
  getMapCurve,
  (zoom, ease, speed, curve) => ({ zoom, ease, speed, curve }),
)

export const MapSelector = {
  getMapData,
  getMapCenter,
  getMapZoom,
  getCurrentMarker,
  getPopUpDetail,
  getIncludeTransient,
  makeMapZoomDetail,
  makeMarkerToolTipDetail
}
